import { ReceptionServiceWithPractitionersSimple } from '@dreryk/egabinet-private-medical-service-frontend-api';

import { createTranslatedText, FormContextValues } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

import { searchCreator, triggerLabelExtractor } from './GroupSessionsReceptionServiceField.utils';
import { GroupSessionsReceptionServiceFieldFormBeanPart } from './GroupSessionsReceptionServiceField.types';

type GroupSessionsReceptionServiceFieldProps = Pick<
   FormContextValues<GroupSessionsReceptionServiceFieldFormBeanPart>,
   'register'
>;

export const GroupSessionsReceptionServiceField = (props: GroupSessionsReceptionServiceFieldProps): JSX.Element => {
   return (
      <Select<ReceptionServiceWithPractitionersSimple>
         testId={'receptionService'}
         triggerLabelExtractor={triggerLabelExtractor}
         controller={props.register('receptionService', { required: false })}
         defaultValue={null}
         placeholder={translationKeys.chooseReceptionService}
         label={translationKeys.receptionService}
         showClearIcon
         searchInputEnabled
      >
         <Select.SearchCreator searchCreator={searchCreator}>
            {({ items }) => (
               <Select.List<ReceptionServiceWithPractitionersSimple> items={items} keyExtractor={'id'}>
                  {(service) => (
                     <Select.Item
                        item={service}
                        testId={service.name}
                        label={<Select.Highlight node={createTranslatedText(service.name)} />}
                     />
                  )}
               </Select.List>
            )}
         </Select.SearchCreator>
      </Select>
   );
};
